import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHeartSelectedEmojiSecondary from './svgs/HeartSelectedEmojiSecondary.js';
import SvgHeartSelectedEmoji from './svgs/HeartSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var heartSelectedEmoji = (props => useIcon(SvgHeartSelectedEmoji, SvgHeartSelectedEmojiSecondary, props));

export { heartSelectedEmoji as default };
